// source: pbtypes/tools/cloud_api/scan.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_scan_output_scan_output_pb = require('../../../pbtypes/gen/scan_output/scan_output_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_output_scan_output_pb);
var pbtypes_tools_cloud_api_data_access_pb = require('../../../pbtypes/tools/cloud_api/data_access_pb.js');
goog.object.extend(proto, pbtypes_tools_cloud_api_data_access_pb);
goog.exportSymbol('proto.cloud_api.ScanPb', null, global);
goog.exportSymbol('proto.cloud_api.UploadScanOutputRequest', null, global);
goog.exportSymbol('proto.cloud_api.UploadScanOutputResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.ScanPb = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_api.ScanPb, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.ScanPb.displayName = 'proto.cloud_api.ScanPb';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.UploadScanOutputRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud_api.UploadScanOutputRequest.repeatedFields_, null);
};
goog.inherits(proto.cloud_api.UploadScanOutputRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.UploadScanOutputRequest.displayName = 'proto.cloud_api.UploadScanOutputRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.UploadScanOutputResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud_api.UploadScanOutputResponse.repeatedFields_, null);
};
goog.inherits(proto.cloud_api.UploadScanOutputResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.UploadScanOutputResponse.displayName = 'proto.cloud_api.UploadScanOutputResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.ScanPb.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.ScanPb.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.ScanPb} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.ScanPb.toObject = function(includeInstance, msg) {
  var f, obj = {
output: (f = msg.getOutput()) && pbtypes_gen_scan_output_scan_output_pb.ScanOutput.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.ScanPb}
 */
proto.cloud_api.ScanPb.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.ScanPb;
  return proto.cloud_api.ScanPb.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.ScanPb} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.ScanPb}
 */
proto.cloud_api.ScanPb.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 8:
      var value = new pbtypes_gen_scan_output_scan_output_pb.ScanOutput;
      reader.readMessage(value,pbtypes_gen_scan_output_scan_output_pb.ScanOutput.deserializeBinaryFromReader);
      msg.setOutput(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.ScanPb.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.ScanPb.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.ScanPb} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.ScanPb.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOutput();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      pbtypes_gen_scan_output_scan_output_pb.ScanOutput.serializeBinaryToWriter
    );
  }
};


/**
 * optional scan_output.ScanOutput output = 8;
 * @return {?proto.scan_output.ScanOutput}
 */
proto.cloud_api.ScanPb.prototype.getOutput = function() {
  return /** @type{?proto.scan_output.ScanOutput} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_scan_output_scan_output_pb.ScanOutput, 8));
};


/**
 * @param {?proto.scan_output.ScanOutput|undefined} value
 * @return {!proto.cloud_api.ScanPb} returns this
*/
proto.cloud_api.ScanPb.prototype.setOutput = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_api.ScanPb} returns this
 */
proto.cloud_api.ScanPb.prototype.clearOutput = function() {
  return this.setOutput(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_api.ScanPb.prototype.hasOutput = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud_api.UploadScanOutputRequest.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.UploadScanOutputRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.UploadScanOutputRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.UploadScanOutputRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.UploadScanOutputRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
organizationId: jspb.Message.getFieldWithDefault(msg, 1, ""),
scanOutput: (f = msg.getScanOutput()) && pbtypes_gen_scan_output_scan_output_pb.ScanOutput.toObject(includeInstance, f),
meshUploadRequestsList: jspb.Message.toObjectList(msg.getMeshUploadRequestsList(),
    pbtypes_tools_cloud_api_data_access_pb.FileUploadRequest.toObject, includeInstance),
photoUploadRequestsList: jspb.Message.toObjectList(msg.getPhotoUploadRequestsList(),
    pbtypes_tools_cloud_api_data_access_pb.FileUploadRequest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.UploadScanOutputRequest}
 */
proto.cloud_api.UploadScanOutputRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.UploadScanOutputRequest;
  return proto.cloud_api.UploadScanOutputRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.UploadScanOutputRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.UploadScanOutputRequest}
 */
proto.cloud_api.UploadScanOutputRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setOrganizationId(value);
      break;
    case 2:
      var value = new pbtypes_gen_scan_output_scan_output_pb.ScanOutput;
      reader.readMessage(value,pbtypes_gen_scan_output_scan_output_pb.ScanOutput.deserializeBinaryFromReader);
      msg.setScanOutput(value);
      break;
    case 3:
      var value = new pbtypes_tools_cloud_api_data_access_pb.FileUploadRequest;
      reader.readMessage(value,pbtypes_tools_cloud_api_data_access_pb.FileUploadRequest.deserializeBinaryFromReader);
      msg.addMeshUploadRequests(value);
      break;
    case 4:
      var value = new pbtypes_tools_cloud_api_data_access_pb.FileUploadRequest;
      reader.readMessage(value,pbtypes_tools_cloud_api_data_access_pb.FileUploadRequest.deserializeBinaryFromReader);
      msg.addPhotoUploadRequests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.UploadScanOutputRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.UploadScanOutputRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.UploadScanOutputRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.UploadScanOutputRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getScanOutput();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_scan_output_scan_output_pb.ScanOutput.serializeBinaryToWriter
    );
  }
  f = message.getMeshUploadRequestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      pbtypes_tools_cloud_api_data_access_pb.FileUploadRequest.serializeBinaryToWriter
    );
  }
  f = message.getPhotoUploadRequestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      pbtypes_tools_cloud_api_data_access_pb.FileUploadRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional string organization_id = 1;
 * @return {string}
 */
proto.cloud_api.UploadScanOutputRequest.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud_api.UploadScanOutputRequest} returns this
 */
proto.cloud_api.UploadScanOutputRequest.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional scan_output.ScanOutput scan_output = 2;
 * @return {?proto.scan_output.ScanOutput}
 */
proto.cloud_api.UploadScanOutputRequest.prototype.getScanOutput = function() {
  return /** @type{?proto.scan_output.ScanOutput} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_scan_output_scan_output_pb.ScanOutput, 2));
};


/**
 * @param {?proto.scan_output.ScanOutput|undefined} value
 * @return {!proto.cloud_api.UploadScanOutputRequest} returns this
*/
proto.cloud_api.UploadScanOutputRequest.prototype.setScanOutput = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_api.UploadScanOutputRequest} returns this
 */
proto.cloud_api.UploadScanOutputRequest.prototype.clearScanOutput = function() {
  return this.setScanOutput(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_api.UploadScanOutputRequest.prototype.hasScanOutput = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated FileUploadRequest mesh_upload_requests = 3;
 * @return {!Array<!proto.cloud_api.FileUploadRequest>}
 */
proto.cloud_api.UploadScanOutputRequest.prototype.getMeshUploadRequestsList = function() {
  return /** @type{!Array<!proto.cloud_api.FileUploadRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_tools_cloud_api_data_access_pb.FileUploadRequest, 3));
};


/**
 * @param {!Array<!proto.cloud_api.FileUploadRequest>} value
 * @return {!proto.cloud_api.UploadScanOutputRequest} returns this
*/
proto.cloud_api.UploadScanOutputRequest.prototype.setMeshUploadRequestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.cloud_api.FileUploadRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud_api.FileUploadRequest}
 */
proto.cloud_api.UploadScanOutputRequest.prototype.addMeshUploadRequests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.cloud_api.FileUploadRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud_api.UploadScanOutputRequest} returns this
 */
proto.cloud_api.UploadScanOutputRequest.prototype.clearMeshUploadRequestsList = function() {
  return this.setMeshUploadRequestsList([]);
};


/**
 * repeated FileUploadRequest photo_upload_requests = 4;
 * @return {!Array<!proto.cloud_api.FileUploadRequest>}
 */
proto.cloud_api.UploadScanOutputRequest.prototype.getPhotoUploadRequestsList = function() {
  return /** @type{!Array<!proto.cloud_api.FileUploadRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_tools_cloud_api_data_access_pb.FileUploadRequest, 4));
};


/**
 * @param {!Array<!proto.cloud_api.FileUploadRequest>} value
 * @return {!proto.cloud_api.UploadScanOutputRequest} returns this
*/
proto.cloud_api.UploadScanOutputRequest.prototype.setPhotoUploadRequestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.cloud_api.FileUploadRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud_api.FileUploadRequest}
 */
proto.cloud_api.UploadScanOutputRequest.prototype.addPhotoUploadRequests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.cloud_api.FileUploadRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud_api.UploadScanOutputRequest} returns this
 */
proto.cloud_api.UploadScanOutputRequest.prototype.clearPhotoUploadRequestsList = function() {
  return this.setPhotoUploadRequestsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud_api.UploadScanOutputResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.UploadScanOutputResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.UploadScanOutputResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.UploadScanOutputResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.UploadScanOutputResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
uploadResponseBatchesList: jspb.Message.toObjectList(msg.getUploadResponseBatchesList(),
    pbtypes_tools_cloud_api_data_access_pb.FileUploadResponseBatch.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.UploadScanOutputResponse}
 */
proto.cloud_api.UploadScanOutputResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.UploadScanOutputResponse;
  return proto.cloud_api.UploadScanOutputResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.UploadScanOutputResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.UploadScanOutputResponse}
 */
proto.cloud_api.UploadScanOutputResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_tools_cloud_api_data_access_pb.FileUploadResponseBatch;
      reader.readMessage(value,pbtypes_tools_cloud_api_data_access_pb.FileUploadResponseBatch.deserializeBinaryFromReader);
      msg.addUploadResponseBatches(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.UploadScanOutputResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.UploadScanOutputResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.UploadScanOutputResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.UploadScanOutputResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUploadResponseBatchesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      pbtypes_tools_cloud_api_data_access_pb.FileUploadResponseBatch.serializeBinaryToWriter
    );
  }
};


/**
 * repeated FileUploadResponseBatch upload_response_batches = 1;
 * @return {!Array<!proto.cloud_api.FileUploadResponseBatch>}
 */
proto.cloud_api.UploadScanOutputResponse.prototype.getUploadResponseBatchesList = function() {
  return /** @type{!Array<!proto.cloud_api.FileUploadResponseBatch>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_tools_cloud_api_data_access_pb.FileUploadResponseBatch, 1));
};


/**
 * @param {!Array<!proto.cloud_api.FileUploadResponseBatch>} value
 * @return {!proto.cloud_api.UploadScanOutputResponse} returns this
*/
proto.cloud_api.UploadScanOutputResponse.prototype.setUploadResponseBatchesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.cloud_api.FileUploadResponseBatch=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud_api.FileUploadResponseBatch}
 */
proto.cloud_api.UploadScanOutputResponse.prototype.addUploadResponseBatches = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.cloud_api.FileUploadResponseBatch, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud_api.UploadScanOutputResponse} returns this
 */
proto.cloud_api.UploadScanOutputResponse.prototype.clearUploadResponseBatchesList = function() {
  return this.setUploadResponseBatchesList([]);
};


goog.object.extend(exports, proto.cloud_api);
